import { useContext } from "react";

import { PhotoIcon } from "@heroicons/react/24/outline";
import { Button } from "@upstageai/ui";

import { BaseTooltip } from "../../components/Tooltip/BaseTooltip";
import { ValidatorFileContext } from "../../hooks/useFile";
import { FILE_PREVIEW_STYLES } from "../../styles/filePreview";
import { cn } from "../../utils/style";

const FileThumbnail = ({
  fileName,
  thumbnailSrc,
}: {
  fileName: string;
  thumbnailSrc: string;
}) => {
  return (
    <>
      {thumbnailSrc ? (
        <img
          src={thumbnailSrc}
          alt={fileName}
          loading="lazy"
          decoding="async"
          className="h-10 min-h-10 w-full object-cover"
        />
      ) : (
        <PhotoIcon className="size-4 min-h-10 text-muted-medium" />
      )}
    </>
  );
};

export const FilePreviewItem = ({
  fileName,
  thumbnailSrc,
  isSelected,
  onClick,
  source,
  docType,
}: {
  fileName: string;
  thumbnailSrc: string;
  isSelected: boolean;
  onClick: () => void;
  source?: string;
  docType?: string;
}) => {
  const { inferenceState } = useContext(ValidatorFileContext);

  const tooltipContent = (
    <div>
      {fileName}
      <br />
      <span className="italic text-muted-foreground">
        {source ? `source: ${source}` : ""}
      </span>
    </div>
  );

  return (
    <BaseTooltip tooltipContent={tooltipContent} side="bottom">
      <Button
        variant="ghost"
        onClick={onClick}
        className={cn(
          FILE_PREVIEW_STYLES.base,
          FILE_PREVIEW_STYLES.sizes.expanded,
          isSelected && FILE_PREVIEW_STYLES.selected,
          "flex flex-col",
        )}
        disabled={inferenceState.isInfering}
      >
        <FileThumbnail fileName={fileName} thumbnailSrc={thumbnailSrc} />

        {docType && (
          <div className="detail h-5 w-full truncate capitalize text-muted-foreground">
            {docType}
          </div>
        )}
      </Button>
    </BaseTooltip>
  );
};
